// import { useGetMap } from "../../services";
import { useTranslation } from "react-i18next";
import { ClockIcon, Timer } from "../../../../../shared/infrastructure";
import { OfferT, OfferViewT } from "../../../domain";
import React, { useMemo } from "react";

type OfferCardMapProps = {
  offer: OfferT;
  showLabel?: boolean;
  view: OfferViewT;
  showDetails: boolean;
};

export const OfferCardMap = ({
  showDetails,
  offer: {
    type,
    order_number,
    origin,
    destination,
    stops,
    approval_id,
    created_at,
    order_stops_map,
  },
  showLabel = false,
  view,
}: OfferCardMapProps): React.ReactElement => {
  const [t] = useTranslation("global");

  const mapLabel = useMemo(() => {
    if (type === "single") {
      return `${t<string>(
        "context.private.components.offer-card-map.order-number"
      )} ${order_number}`;
    }

    return t<string>("context.private.components.offer-card-map.dedicated");
  }, [t, type, order_number]);

  const route = useMemo(
    () => [
      {
        longitude: origin.longitude,
        latitude: origin.latitude,
      },
      ...(stops ?? []).map(({ latitude, longitude }) => ({
        longitude,
        latitude,
      })),
      {
        longitude: destination.longitude,
        latitude: destination.latitude,
      },
    ],
    [
      destination.latitude,
      destination.longitude,
      origin.latitude,
      origin.longitude,
      stops,
    ]
  );

  // const routeString = useMemo(
  useMemo(() => route.map((r) => `${r.latitude};${r.longitude}`), [route]);

  // const { data, isLoading } = useGetMap(routeString);

  return (
    <section
      className={[
        showDetails ? "hidden xl:block" : "block",
        "md:h-[134px] md:w-[120px] lg:h-[182px] lg:w-[150px]",
        "relative h-[112px] w-full overflow-hidden rounded-[5px] xl:h-full xl:w-[200px]",
      ].join(" ")}
    >
      {order_stops_map ? (
        <img
          src={order_stops_map}
          alt={`${approval_id}-${order_number}-${view}`}
          className="h-full w-full object-cover md:mt-10 md:object-fill xl:mt-0"
        />
      ) : (
        <div
          className={`h-full w-full bg-gray-200 object-contain ${
            /* isLoading ? "animate-pulse" : */ ""
          }`}
        />
      )}
      {showLabel && (
        <span
          className={[
            "absolute top-0 left-0 flex w-full items-center justify-center text-sm",
            "md:top-0 md:left-0 md:px-2 md:py-1 md:text-xs",
            "lg:w-full lg:justify-center xl:w-auto xl:justify-start",
            "z-[100] rounded-tl-[5px] rounded-tr-[5px] bg-black py-1 font-medium text-white md:my-1 md:rounded-[5px] md:text-sm xl:top-[8px] xl:left-[8px] xl:px-[12px]",
            "md:w-auto md:justify-start",
          ].join(" ")}
        >
          <div className="flex items-center justify-center gap-x-4">
            {mapLabel}

            <div className="flex items-center gap-x-1 md:hidden">
              <ClockIcon fill="#FFBD2E" />
              <Timer
                className="overflow-hidden text-ellipsis whitespace-nowrap"
                date={created_at}
              />
            </div>
          </div>
        </span>
      )}
    </section>
  );
};
